require('../scss/admin_user.scss')